/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteResult } from '../../models/delete-result';

export interface StorageControllerDeleteObjectFile$Params {
  key: string;
}

export function storageControllerDeleteObjectFile(
  http: HttpClient,
  rootUrl: string,
  params: StorageControllerDeleteObjectFile$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<DeleteResult>> {
  const rb = new RequestBuilder(
    rootUrl,
    storageControllerDeleteObjectFile.PATH,
    'delete',
  );
  if (params) {
    rb.path('key', params.key, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeleteResult>;
      }),
    );
}

storageControllerDeleteObjectFile.PATH = '/storage/object/key/{key}';
